export const LOCALE_KEY = 'RaStore.locale';
